import { enableMapSet } from 'immer';

import { Settings } from 'luxon';
import currentLocale from 'utils/locale/currentLocale';

Settings.defaultLocale = currentLocale.toString();

export * from './types';

export * from './api';
export * from './components';
export * from './hooks';
export * from './modals';
export * from './pages';
export * from './utils/bytes';
export * from './utils/dates';
export * from './utils/files';
export * from './utils/legacy';
export * from './utils/numbers';
export * from './utils/strings';
export * from './state';
export * from './views';

enableMapSet();
